import { Dropdown } from 'antd';
import React, { useCallback, useMemo } from 'react';
import { createPortal } from 'react-dom';
import { connect } from 'react-redux';

import {
  getTaskProjectIdListSelector,
  isTaskCreator,
} from '../../../../redux/tasks/taskEntities/selectors';
import TaskContextMenu from './TaskContextMenu';
import { isWorkfloSuperAdminSelector } from '../../../../redux/user/selectors';
import { isCurrentWorkspaceOwnerOrAdmin } from '../../../../redux/general/selectors';
import { hasDeleteTaskRightsBasedOnRoleSelector } from '../../../../redux/dashboards/selectors';
import { isEmpty } from 'lodash';

const trigger = ['contextMenu'];

const TaskContextMenuDropdown = ({
  isOpen,
  hasDeleteTaskRightsBasedOnRole,
  isTaskCreator,
  isWorkfloSuperAdmin,
  isWorkspaceOwnerAdmin,
  isWorkspaceTasksScreen,
  position,
  selectedTaskId,
  setIsEdit,
  toggleDropdown,
}) => {
  const handleOnOpenChange = useCallback(
    (visible) => toggleDropdown(visible),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const menuStyle = useMemo(
    () => ({
      position: 'absolute',
      left: position?.x,
      top: position?.y,
      zIndex: 1000,
    }),
    [position],
  );

  return createPortal(
    <Dropdown
      menu={{
        items: TaskContextMenu({
          hasTaskDeleteRights: hasDeleteTaskRightsBasedOnRole || isTaskCreator, // isWorkspaceOwnerAdmin || isWorkfloSuperAdmin,
          isWorkspaceTasksScreen,
          setIsEdit,
          taskId: selectedTaskId,
        }),
      }}
      open={isOpen}
      onOpenChange={handleOnOpenChange}
      trigger={trigger}
    >
      <div style={menuStyle} />
    </Dropdown>,
    document.body,
  );
};

const mapStateToProp = (state, ownProps) => {
  const taskProjectIdList = getTaskProjectIdListSelector(state, {
    taskId: ownProps?.selectedTaskId,
  });

  return {
    hasDeleteTaskRightsBasedOnRole: isEmpty(taskProjectIdList)
      ? false
      : taskProjectIdList?.some((projectId) =>
          hasDeleteTaskRightsBasedOnRoleSelector(state, { projectId }),
        ),
    isTaskCreator: isTaskCreator(state, { taskId: ownProps?.selectedTaskId }),
    isWorkspaceOwnerAdmin: isCurrentWorkspaceOwnerOrAdmin(state),
    isWorkfloSuperAdmin: isWorkfloSuperAdminSelector(state),
  };
};

export default connect(mapStateToProp)(TaskContextMenuDropdown);
